import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const InfoCardInfoIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM11.1634 8.23486L9.91094 14.1162C9.82305 14.541 9.94756 14.7827 10.2918 14.7827C10.5335 14.7827 10.8997 14.6948 11.1487 14.4751L11.0389 14.9951C10.68 15.4272 9.88896 15.7422 9.20781 15.7422C8.32891 15.7422 7.95537 15.2148 8.19707 14.0942L9.11992 9.7583C9.20049 9.39209 9.12725 9.26025 8.76103 9.17236L8.19707 9.06982L8.29961 8.59375L11.1634 8.23486ZM10 6.875C9.30964 6.875 8.75 6.31536 8.75 5.625C8.75 4.93464 9.30964 4.375 10 4.375C10.6904 4.375 11.25 4.93464 11.25 5.625C11.25 6.31536 10.6904 6.875 10 6.875Z",
    fill: "#5C5C5C"
  }));
};
export default InfoCardInfoIcon;